import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
          分类浏览
        </h2>
        <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
          海量韩漫分类整理，轻松找到你喜欢的类型
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center justify-center p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors duration-300">
              <i className={`${cat.icon} text-xl text-primary-600`}></i>
            </div>
            <span className="mt-3 text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}